import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../../../shared/components/Notistack/Notistack';

export const requestUpdateRequirements = (lenderId: string, numericId: number, requirements: string) => {
  const path = `/lender-service/lenders/${numericId}/requirements`;
  const config = { headers: { 'Content-Type': 'application/json' } };

  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, requirements, config);
      Notistack.successMessage('Requirements - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
